import { render, staticRenderFns } from "./ColumnMappingDropdown.vue?vue&type=template&id=f2bf791a&scoped=true&lang=html&"
import script from "./ColumnMappingDropdown.vue?vue&type=script&lang=js&"
export * from "./ColumnMappingDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bf791a",
  null
  
)

export default component.exports